<div class="card" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column" *ngIf="currentSubscriber">
  <div class="card-body">
    <h3 *ngIf="!selfPay?.isCobraInitial && !selfPay.isLwopInitial">Subscriber</h3>
    <form nativeControlElement #selfPaySubscriberForm="ngForm" #formContainer>
      <fieldset [disabled]="isPerspay">
        <div *ngIf="selfPay?.isLWOP">
          <ng-container *ngIf="selfPay?.isInitial">
            <ng-container *ngTemplateOutlet="endCoverageDateSection"></ng-container>
          </ng-container>
          <h3 *ngIf="selfPay?.isInitial">Subscriber</h3>
          <ng-container *ngTemplateOutlet="demographicsSection"></ng-container>
          <ng-container *ngTemplateOutlet="socialSecurityDisabilitySection"></ng-container>
          <ng-container *ngTemplateOutlet="coverageSection"></ng-container>
          <ng-container *ngTemplateOutlet="actionsSection"></ng-container>
          <ng-container *ngTemplateOutlet="medicareSection"></ng-container>
          <ng-container *ngTemplateOutlet="iWantToSection"></ng-container>
          <ng-container *ngTemplateOutlet="retireeLifeSection"></ng-container>
          <ng-container *ngTemplateOutlet="premiumSurchargeSection"></ng-container>
        </div>

        <div *ngIf="selfPay?.isPebbRetireeInitial">
          <ng-container *ngTemplateOutlet="demographicsSection"></ng-container>
          <ng-container *ngTemplateOutlet="medicareSection"></ng-container>
          <ng-container *ngTemplateOutlet="actionsSection"></ng-container>
          <ng-container *ngTemplateOutlet="iWantToSection"></ng-container>
          <ng-container *ngTemplateOutlet="retireeLifeSection"></ng-container>
          <ng-container *ngTemplateOutlet="premiumSurchargeSection"></ng-container>
        </div>

        <div *ngIf="selfPay?.isPebbRetireeSOE">
          <ng-container *ngTemplateOutlet="demographicsSection"></ng-container>
          <ng-container *ngTemplateOutlet="medicareSection"></ng-container>
          <ng-container *ngTemplateOutlet="iWantToSection"></ng-container>
          <ng-container *ngTemplateOutlet="premiumSurchargeSection"></ng-container>
        </div>

        <div *ngIf="selfPay?.isPebbRetireeOE || selfPay?.isCOBRA">
          <ng-container *ngIf="selfPay?.isInitial">
            <ng-container *ngTemplateOutlet="endCoverageDateSection"></ng-container>
          </ng-container>
          <h3 *ngIf="selfPay?.isCobraInitial">Subscriber</h3>
          <ng-container *ngTemplateOutlet="demographicsSection"></ng-container>
          <ng-container *ngTemplateOutlet="medicareSection"></ng-container>
          <ng-container *ngTemplateOutlet="iWantToSection"></ng-container>
          <ng-container *ngIf="selfPay?.isSebbCobraSOE">
            <ng-container *ngTemplateOutlet="terminateCoverageSection"></ng-container>
          </ng-container>
          <ng-container *ngTemplateOutlet="premiumSurchargeSection"></ng-container>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around">
          <button (click)="previous.emit()" class="btn btn-secondary">Previous</button>
          <button (click)="pushContinue(formContainer)" class="btn btn-primary">Proceed to dependent form</button>
        </div>
      </fieldset>

      <!-- NOTE: Templates need to stay inside the <form> element, otherwise validation breaks (ngForm is missing controls outside of <form>)-->
      <ng-template #demographicsSection>
        <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
          <div class="form-group" fxFlex="30">
            <label for="socialSecurityNumber" id="ssnLabel">Social Security number</label>
            <kendo-maskedtextbox
              [mask]="env.ssnMask"
              [pattern]="env.ssnItinRegex"
              [(ngModel)]="currentSubscriber.socialSecurityNumber"
              [maskOnFocus]="true"
              name="socialSecurityNumber"
              aria-labelledby="ssnLabel"
              #ssn="ngModel"
              class="form-control"
              [forbiddenValues]="env.invalidSSNValues"
            ></kendo-maskedtextbox>
          </div>
          <div class="form-group" fxFlex="25">
            <date-picker
              #birthDate="ngModel"
              name="birthDate"
              label="Date of birth"
              required
              [(ngModel)]="currentSubscriber.birthDate"></date-picker>
          </div>
          <div class="form-group" fxFlex="25">
            <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
              <label for="birthSexId">Sex assigned at birth</label>
              <select class="form-control" name="birthSexId" id="birthSexId" [(ngModel)]="currentSubscriber.birthSexId" required>
                <option></option>
                <option *ngFor="let birthSex of lookups.birthSexes | isObsolete" [ngValue]="birthSex.birthSexId">{{ birthSex.birthSexName }}</option>
              </select>
            </div>

            <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
              <div class="hca-soe-small-note" fxFlex="100">
                This field is required for health care services
              </div>
            </div>
          </div>
        </div>
        <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
          <div class="form-group" fxFlex="70">
            <label for="lastName">Last name</label>
            <input required type="text" class="form-control" name="lastName" id="lastName" [(ngModel)]="currentSubscriber.lastName" />
          </div>
          <div class="form-group" fxFlex="20" *ngIf="!genderIdentityDisabled">
            <label for="genderIdentityId">Gender Identity</label>
            <select class="form-control" id="genderIdentityId" [required]="false" name="genderIdentityId" [(ngModel)]="currentSubscriber.genderIdentityId">
              <option></option>
              <option *ngFor="let genderIdentity of lookups.genderIdentities | isObsolete" [ngValue]="genderIdentity.genderIdentityId">{{ genderIdentity.genderIdentityName }}</option>
            </select>
          </div>
        </div>
        <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
          <div class="form-group" fxFlex="40">
            <label for="firstName">First name</label>
            <input required type="text" class="form-control" id="firstName" name="firstName" [(ngModel)]="currentSubscriber.firstName" />
          </div>
          <div class="form-group" fxFlex="30">
            <label for="middleName">Middle name</label>
            <input type="text" class="form-control" maxLength="15" id="middleName" name="middleName" [(ngModel)]="currentSubscriber.middleName" />
          </div>
          <div class="form-group" fxFlex="20" *ngIf="!genderIdentityDisabled">
            <span class="hca-soe-small-note" fxFlex="100">
              This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. 
              Gender X means a gender that is not exclusively male nor female. To learn more visit 
              <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X</a>.
            </span>
          </div>
        </div>
        <div class="form-row" fxLayout="row" fxLayout.lt-md="column">
          <div fxLayout="column" fxFlex="30">            
          </div>
          <div fxFlex="25">
            <!-- left in case this is needed for spacing/alignment of suffix field -->
          </div>
          <div class="form-group" fxFlex="10">
            <label for="suffix">Suffix</label>
            <input pattern="[a-zA-Z]*" type="text" class="form-control" id="suffix" name="suffix" [(ngModel)]="currentSubscriber.suffix" placeholder="JR, SR" />
          </div>
        </div>
        <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
          <div fxFlex="40" class="form-group">
            <label for="homePhoneNumber">Phone number</label>
            <input pattern="[0-9]*" type="text" class="form-control" id="homePhoneNumber" name="homePhoneNumber" [(ngModel)]="currentSubscriber.homePhoneNumber" />
          </div>
          <div fxFlex="40" class="form-group">
            <label for="workPhoneNumber">Alternate phone number</label>
            <input type="text" class="form-control" id="workPhoneNumber" name="workPhoneNumber" [(ngModel)]="currentSubscriber.workPhoneNumber" />
          </div>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isPebbCobraOE">
          <h4 style="margin-bottom: 0px">Permanent street address (PO Box is not allowed)</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isPebbCobraInitial || selfPay.isPebbRetireeOE">
          <h4 style="margin-bottom: 0px">Permanent street address (PO Box not allowed)</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isSebbCobraOE">
          <h4 style="margin-bottom: 0px">Street Address</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isSOE || selfPay.isSebbCobraInitial">
          <h4 style="margin-bottom: 0px">Residential address</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isLwopInitial || selfPay.isLwopOE">
          <h4 style="margin-bottom: 0px">Street address</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay.isPebbRetireeInitial">
          <h4 style="margin-bottom: 0px">Permanent Residential street address (PO Box is not allowed)</h4>
        </div>
        <div class="form-row" fxLayout="row" fxFlexFill>
          <h4>
            <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
            If you move, you must report your new address to the {{agency}} Program <b>no later than 60 days</b> after you move.
          </h4>
        </div>

        <address #residentialAddress view="inline" name="residentialAddress" [(ngModel)]="currentSubscriber.formResidentialAddress"
            [hideCountry]="selfPay?.isInitial || selfPay?.isOE"></address>

        <div *ngIf="selfPay?.medicareAvailable">
          <p>
            Enrollment in a Medicare supplement plan, a Medicare Advantage with Part D plan <ng-container *ngIf="!selfPay.isRetireeInitial && !selfPay.isPebbCobraInitial">(MAPD)</ng-container> or UMP Classic Medicare with Part D (PDP) has
            specific requirements associated with permanent residential addresses. PO Boxes and out-of-country addresses will be reviewed
            by HCA for eligibility. Proof of permanent residence in the United States may need to be provided to determine you or your dependent
            reside in the health plan service area.
          </p>
        </div>

        <div class="form-row" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" style="margin-bottom: 20px">
          <checkbox name="mailingSame" bold [(ngModel)]="selfPay.formJson.mailingAddressSameAsResidential">Mailing address same as  {{ selfPay?.isPebbCobraOE ? 'street' : 'residential' }}</checkbox>
        </div>
        <div *ngIf="!selfPay.formJson.mailingAddressSameAsResidential">
          <h4>Mailing Address</h4>
          <address #mailingAddress view="inline" name="mailingAddress" [(ngModel)]="currentSubscriber.mailingAddress"
            [hideCounty]="!selfPay?.isPebbCobraSOE"
            [hideCountry]="selfPay?.isRetireeInitial || selfPay?.isCobraInitial || selfPay?.isPebbLwopInitial"></address>
        </div>

        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="selfPay?.isPebbRetireeInitial || selfPay.isPebbCobraInitial">
          <h4>
            <span class="h4">
              1.	If you are enrolled in Medicare, this information needs to match your Medicare record to avoid delay to coverage starting.
            </span>
          </h4>
        </div>
      </ng-template>

      <ng-template #coverageSection>
        <!-- Current coverage check -->
        <div *ngIf="selfPay.isPebbCobraInitial || selfPay.isPebbCobraOE || selfPay.isPebbLwopInitial" class="form-row" fxFlexFill>
          <div fxLayout="row" fxFlexFill style="margin-bottom: 20px">
            <kendo-formfield [orientation]="'horizontal'" fxFlex="100">
              <label class="k-label">Are you or any eligible dependents enrolled in {{agency}} insurance coverage under another account?</label>
              <yes-no
                name="coveredByOtherPEBBAccountInd"
                style="width: auto;"
                orientation="horizontal-list"
                [stretch]="false"
                [required]="true"
                [(ngModel)]="currentSubscriber.coveredByOtherPEBBAccountInd"
                ></yes-no>
            </kendo-formfield>
          </div>
        </div>
        <!-- Continue coverage section -->
        <div *ngIf="selfPay.isLWOP" class="form-row" fxFlexFill>
          <div class="form-row" fxFlexFill style="margin-bottom: 20px">
            <div fxLayout="column" fxFlexFill>
              <span class="soe-form-small-header">Continue coverage (Select all that apply)</span>
              <p *ngIf="!selfPay.isLwopOE">
                You may continue coverage you were enrolled in on the day your {{agency}} health plan coverage ended. If you are enrolled in a Flexible Spending
                Arrangement (FSA) or Limited Purpose FSA and would like to continue it, call Navia Benefit Solutions at 1-800-669-3539.  Navia must receive
                your request no later than 60 days after the postmark date on Navia's COBRA election notice.
              </p>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
                <div class="k-form-field bigger">
                  <checkbox name="medicalContinueCoverageInd" [(ngModel)]="currentSubscriber.medicalContinueCoverageInd">Medical</checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="dentalContinueCoverageInd" [(ngModel)]="currentSubscriber.dentalContinueCoverageInd">Dental</checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="visionContinueCoverageInd" [(ngModel)]="currentSubscriber.visionContinueCoverageInd">Vision</checkbox>
                </div>
                <div class="k-form-field bigger" *ngIf="!selfPay.isSebbLWOP && !selfPay.isPebbLwopOE">
                  <checkbox name="longTermDisabilityContinueCoverageInd" [(ngModel)]="currentSubscriber.longTermDisabilityContinueCoverageInd">
                    Long-term disability insurance (only if on educational or USERRA military leave) insurance
                  </checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Terminate coverage  Unpaid -->
        <ng-container *ngIf="selfPay.isLWOP">
          <ng-container *ngTemplateOutlet="terminateCoverageSection"></ng-container>
        </ng-container>
        
        <!-- Life and accidental death and dismemberment -->
        <div *ngIf="selfPay.isLwopInitial" class="form-row" fxFlexFill>
          <span class="soe-form-small-header">Life and accidental death and dismemberment (AD&D) insurance</span>
          <div class="hca-self-pay-checklist fxGap-medium-sm" fxLayout="column" fxLayoutAlign="space-between start" style="margin-bottom: 20px">
            <radio
              name="lifeAndAddAcknowledgeInd"
              [required]="currentSubscriber.lifeAndADDContinueCoverageInd"
              [value]="true"
              [(ngModel)]="currentSubscriber.lifeAndADDAcknowlegeInd">
              Yes, I wish to continue the life and AD&D insurance I had as an employee. I understand I will need to pay MetLife directly for basic life
              insurance and basic AD&D Insurance in addition to any supplemental life and supplemental AD&D insurance I have while on {{agency}} Continuation
              Coverage (Unpaid Leave). If you wish to decrease your supplemental life and/or AD&D insurance amounts while on {{agency}} Continuation Coverage
              (Unpaid Leave), please call MetLife at
              <span *ngIf="selfPay.isPEBB" style="white-space: nowrap; font: inherit;">1-866-548-7139</span><span *ngIf="selfPay.isSEBB" style="white-space: nowrap; font: inherit;">1-833-854-9624</span>.
            </radio>
            <radio
              name="lifeAndAddAcknowledgeInd"
              [required]="currentSubscriber.lifeAndADDContinueCoverageInd"
              [value]="false"
              [(ngModel)]="currentSubscriber.lifeAndADDAcknowlegeInd">
                No, I do not wish to continue the life and AD&D insurance I had as an employee. I understand I must reapply for supplemental life insurance and AD&D insurance when I regain eligibility
                and I must submit evidence of insurability to MetLife for supplemental life insurance. I understand that MetLife must receive my MetLife Enrollment/Change form through MetLife's 
                <a *ngIf="selfPay.isSEBB" href="mybenefits.metlife.com/wasebb" target="_blank"> MyBenefits</a>
                <a *ngIf="selfPay.isPEBB" href="https://mybenefits.metlife.com/wapebb" target="_blank"> MyBenefits</a>                              
                no later than 31 days after the date I regain eligibility.
            </radio>
          </div>
        </div>

        <!-- Long term disability -->
        <div *ngIf="selfPay.isPebbLwopInitial" class="form-row" fxFlexFill>
          <span class="soe-form-small-header">Long-term disability (LTD) insurance</span>
          <p>
            This section applies only to employees on approved educational leave, or who are called to active duty in the uniformed services as defined under Uniformed Services Employment and
            Reemployment Rights Act (USERRA).
          </p>
          <div class="hca-self-pay-checklist fxGap-medium-sm" fxLayout="column" fxLayoutAlign="space-between start" style="margin-bottom: 20px" fxFlex="90">
            <radio-list
              name="sltdSelPlan"
              orientation="vertical"
              [(ngModel)]="selfPay.formJson.ltdPlanName"
              [items]="{
                '60% coverage level': sltdSixtyPlan.planName,
                '50% coverage level': sltdFiftyPlan.planName,
                'Decline employee-paid LTD': 'Decline employee-paid LTD'
              }"></radio-list>
          </div>
        </div>

        <!-- Coverage section -->
        <div *ngIf="selfPay.isCOBRA || selfPay.isHcaCorrectionEvent" class="form-row" fxFlexFill>
          <div class="form-row" fxFlexFill style="margin-bottom: 20px">
            <div>
              You may choose to continue coverage and then terminate coverage at a future date by selecting to both continue and terminate coverage and providing a termination date and reason below.
            </div>
            <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
              <span class="soe-form-small-header">Medical coverage (Select all that apply)</span>
              <div fxLayout="column">
                <div fxLayout="column" fxFlex="50">
                  <div class="k-form-field bigger" style="margin-bottom: 15px">
                    <checkbox (change)="updateCoverageContinue($event, 'medicalDoNotContinueCoverage')" name="continueMedical" [(ngModel)]="currentSubscriber.medicalContinueCoverageInd">Continue coverage</checkbox>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="50">
                  <div class="k-form-field bigger">
                    <checkbox (change)="updateCoverageContinue($event, 'medicalContinueCoverageInd')" name="doNotContinueMedical" [(ngModel)]="currentSubscriber.medicalDoNotContinueCoverage">Do not continue coverage</checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
              <span class="soe-form-small-header">Dental coverage</span>
              <div fxLayout="column">
                <div fxLayout="column" fxFlex="50">
                  <div class="k-form-field bigger" style="margin-bottom: 15px">
                    <checkbox (change)="updateCoverageContinue($event, 'dentalDoNotContinueCoverage')" name="continueDental" [(ngModel)]="currentSubscriber.dentalContinueCoverageInd">Continue coverage</checkbox>
                  </div>
                </div>
                <div fxLayout="column" fxFlex="50">
                  <div class="k-form-field bigger">
                    <checkbox (change)="updateCoverageContinue($event, 'dentalContinueCoverageInd')" name="doNotContinueDental" [(ngModel)]="currentSubscriber.dentalDoNotContinueCoverage">Do not continue coverage</checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- VISION -->
          <div *ngIf="selfPay.isSEBB" fxLayout="column" fxFlex="100" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
            <span class="soe-form-small-header">Vision coverage (Select all that apply)</span>
            <div fxLayout="column">
              <div fxLayout="column" fxFlex="50">
                <div class="k-form-field bigger" style="margin-bottom: 15px">
                  <checkbox (change)="updateCoverageContinue($event, 'visionDoNotContinueCoverage')"  name="continueVision" [(ngModel)]="currentSubscriber.visionContinueCoverageInd">Continue coverage</checkbox>
                </div>
              </div>
              <div fxLayout="column" fxFlex="50">
                <div class="k-form-field bigger">
                  <checkbox (change)="updateCoverageContinue($event, 'visionContinueCoverageInd')" name="doNotContinueVision" [(ngModel)]="currentSubscriber.visionDoNotContinueCoverage">Do not continue coverage</checkbox>
                </div>
              </div>
            </div>
          </div>
          <!-- TERMINATE HERE -->
          <div *ngIf="selfPay.isCOBRA || selfPay.isHcaCorrectionEvent" class="form-row" fxFlexFill>
            <ng-container *ngTemplateOutlet="terminateCoverageSection"></ng-container>
          </div>
          <h4>
            <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
            If you terminate all coverage, you will not be eligible to enroll again in {{agency}} Continuation Coverage unless you regain eligibility.
          </h4>
          <div *ngIf="!selfPay.isOE">
            <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template #actionsSection>
        <!-- Actions section -->
        <div *ngIf="selfPay.isRetireeInitial" class="form-row" fxFlexFill>
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
            <span class="soe-form-small-header">Actions (check one)</span>
            <div class="hca-self-pay-checklist fxGap-medium-sm" fxLayout="column" fxLayoutAlign="space-between start" style="margin-bottom: 20px">
              <radio name="enrolling" required value="enrolling" [(ngModel)]="currentSubscriber.actionsCode">
                <b>Enrolling: </b>I am a new retiree, separating employee, or a surviving dependent requesting to enroll in coverage.
              </radio>
              <radio name="enrollAfterDefer" required value="enrollAfterDefer" [(ngModel)]="currentSubscriber.actionsCode">
                <b>Enrolling after deferring<ng-container *ngIf="selfPay.isRetireeInitial"> coverage</ng-container>: </b> I am a retiree or a surviving dependent who is enrolling after having previously deferred.
                (<ng-container *ngIf="selfPay.isRetireeInitial">In most cases, you</ng-container><ng-container *ngIf="!selfPay.isRetireeInitial">You</ng-container> will need to provide proof of continuous enrollment in one or more qualifying coverages, with start and end dates.) 
              </radio>
              <radio name="deferring" required value="deferring" [(ngModel)]="currentSubscriber.actionsCode" (ngModelChange)="deferringChange()">
                <b>I want to Defer: </b> Defer (postpone) my coverage. <ng-container *ngIf="!selfPay.isRetireeInitial">Except as stated below, this defers coverage for all eligible dependents.</ng-container>
              </radio>
              <div *ngIf="currentSubscriber.actionsCode === 'enrollAfterDefer'" fxLayout="row" fxLayoutAlign="start space-between">
                <date-picker
                  #ead="ngModel"
                  name="ead"
                  labelFlex="50"
                  inputFlex="50"
                  [required]="currentSubscriber.actionsCode === 'enrollAfterDefer'"
                  [(ngModel)]="currentSubscriber.enrollAfterDeferDateInitial">
                  <span aria-hidden="true">Date other qualifying coverage ended </span>
                </date-picker>
              </div>
              <radio *ngIf="false" name="seperating" required value="seperating" [(ngModel)]="currentSubscriber.actionsCode">
                <b>Separating: </b>I am separating from service and am eligible for retirement as a separated employee under Plan 2, Plan 3 or a higher-education retirement plan. 
              </radio>
              <div *ngIf="currentSubscriber.actionsCode === 'seperating'" fxLayout="row" fxLayoutAlign="start space-between">
                <date-picker
                  #sd="ngModel"
                  name="sd"
                  [required]="currentSubscriber.actionsCode === 'seperating'"
                  [(ngModel)]="currentSubscriber.seperatingDate">
                  <span aria-hidden="true">Separating as of date </span>
                </date-picker>
              </div>
              <!-- US 26977 -->
              <div fxLayout="row" fxFlex="60" fxLayoutAlign="start space-between" *ngIf="currentSubscriber.actionsCode !== 'deferring'">
                <date-picker
                  #covdt="ngModel"
                  name="covdt"
                  label="Requested coverage effective date"
                  labelFlex="50"
                  inputFlex="50"
                  required
                  [(ngModel)]="currentSubscriber.coverageEffectiveDate">
                </date-picker>
              </div>
              <div class="form-group" fxFlexFill fxFlex="100" *ngIf="currentSubscriber.actionsCode !== 'deferring'" fxLayout="row" fxLayoutAlign="start space-between">
                <div fxFlex="20">
                  <label style="margin-left: 0px;" for="retirementPlan">Washington State Retirement plan</label>
                </div>
                <div fxFlex="35">
                  <span>Not sure which plan you have? 
                    <br/>
                    Contact Department of Retirement Systems (DRS) or your higher education institution.
                  </span>
                </div>
                <div fxFlex="40" >
                  <select required class="form-control" name="retirementPlan" id="retirementPlan" [(ngModel)]="currentSubscriber.retirementPlan">
                    <option></option>
                    <option *ngFor="let retPlan of env.retirementPlans" [ngValue]="retPlan">{{ retPlan }}</option>
                  </select>
                </div>
              </div>     
              <div fxLayout="row" fxFlex="60" fxLayoutAlign="start space-between" *ngIf="currentSubscriber.actionsCode !== 'deferring'">
                <date-picker
                  #rtd="ngModel"
                  name="rtd"
                  label="Retirement date (or separation date for Plan 2 or 3, or higher-education retirement plans)"
                  labelFlex="50"
                  inputFlex="50"
                  [required]="true"
                  [(ngModel)]="currentSubscriber.retirementDate">
                </date-picker>
              </div>                       
            </div>
          </div>
        </div>
      </ng-template> 

      <ng-template #medicareSection>
        <!-- Medicare section -->
        <div *ngIf="(selfPay?.medicareAvailable || selfPay?.isCOBRA) && currentSubscriber.actionsCode !== 'deferring'"  class="form-row" fxFlexFill style="margin-bottom: 20px">
          <span class="soe-form-small-header">Medicare information</span>
          <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
          <div fxLayout="row" fxFlexFill class="fxGap-large">
            <div fxLayout="column">
              <div>
                <label for="medicarePartA" class="k-label">Part A (hospital)</label>  
              </div>
              <yes-no
                name="medicarePartA"
                style="width: auto;"
                orientation="horizontal-list"
                [stretch]="false"
                [required]="selfPay?.isInitial"
                [(ngModel)]="currentSubscriber.medicarePartAInd"
                (change)="updateTobaccoBasedOnMedicare()"
                ></yes-no>
            </div>
            <div class="form-inline" *ngIf="selfPay.isSebbCOBRA">
              <div class="form-group">
                <date-picker
                  #medicarePartADate="ngModel"
                  name="medicarePartADate"
                  [min]="currentSubscriber.birthDate"
                  [required]="currentSubscriber.medicarePartAInd"
                  [(ngModel)]="currentSubscriber.medicarePartADate">
                  If yes, enter the effective date shown on the Medicare card
                </date-picker>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlexFill style="margin-top: 15px"  class="fxGap-large">
            <div fxLayout="column">
              <div>
                <label for="medicarePartB" class="k-label">Part B (medical)</label>
              </div>
              <yes-no
                name="medicarePartB"
                style="width: auto;"
                orientation="horizontal-list"
                [stretch]="false"
                [required]="selfPay?.isInitial"
                [(ngModel)]="currentSubscriber.medicarePartBInd"
                (change)="updateMedicarePartB($event)"
                ></yes-no>
            </div>
            <div class="form-inline" *ngIf="selfPay.isSebbCOBRA">
              <date-picker
                #medicarePartBDate="ngModel"
                name="medicarePartBDate"
                [min]="currentSubscriber.birthDate"
                [required]="currentSubscriber.medicarePartBInd"
                [(ngModel)]="currentSubscriber.medicarePartBDate">
                If yes, enter the effective date shown on the Medicare card
              </date-picker>
            </div>
          </div>

          <div *ngIf="!selfPay?.isSebbCOBRA" class="form-group" fxFill>
            <label for="medicareNumber">Medicare number <b>Please verify the accuracy of your Medicare Beneficiary Number (MBI)</b></label>
            <input pattern="[a-zA-Z0-9]*" type="text" class="form-control" id="medicareNumber" name="medicareNumber" [(ngModel)]="currentSubscriber.medicareNumber" minlength="11" maxlength="12" />
          </div>
          
          <p *ngIf="selfPay?.isPebbRetireeOE">
            If yes, proof is required. Upload or mail a copy of your entire Medicare benefit verification letter or a copy of your Medicare card if we
            don't already have a copy. <b>You will not be enrolled until your proof of Medicare is received.</b> If mailing, write your last name and
            the last four digits of your Social Security Number on the copy so we can identify your account. If you are eligible for Medicare, you must
            enroll and stay enrolled in both Medicare Part A and Part B. You cannot be enrolled in separate Part D coverage if your selected plan includes
            drug coverage.
          </p>
          <p *ngIf="selfPay?.isPebbRetireeInitial">
            If Yes, proof is required. Upload or mail a copy of all pages of your Medicare benefit verification letter or a copy of your Medicare card.
            Write your last name and the last four digits of your Social Security Number on the copy so we can identify your account. <b>You will not be
            enrolled until your proof of Medicare is received.</b> If you are eligible for Medicare, you must enroll and stay enrolled in both Medicare Part A
            and Part B.  You cannot be enrolled in separate Part D coverage if your selected plan includes drug coverage.
          </p>
          <p *ngIf="selfPay?.isPebbRetireeSOE">
            If Yes, proof is required. Upload or mail a copy of all pages of your Medicare benefit verification letter or a copy of your Medicare card if we don't
            already have a copy. If mailing, write your last name and the last four digits of your Social Security Number on the copy so we can identify your account.
            If you are eligible for Medicare, you must enroll and stay enrolled in both Medicare Part A and Part B to keep PEBB retiree health plan coverage.
          </p>
          <ng-container *ngIf="selfPay?.isSebbCobraInitial">
            <p>
              If Yes, proof is required. Upload or mail a copy of your Medicare benefit verification letter or a copy of your Medicare card. Write your full name and the
              last four digits of your Social Security number on the copy. 
            </p>
            <p>
              You could face premium penalties if you don't enroll in Medicare Part A and Part B when you are eligible. You cannot waive Medicare while on COBRA coverage
              or while enrolled in retiree coverage.
            </p>
          </ng-container>
          <p *ngIf="selfPay?.isPebbCOBRA">
            If yes, proof is required. Upload or mail a copy of your Medicare benefit verification letter or a copy of your Medicare card. Write your full 
            name and the last four digits of your Social Security number on the copy.
            <b *ngIf="selfPay.isOE || selfPay.isInitial">You will not be enrolled until your proof of Medicare is received.</b>
            You could face penalties if you don't enroll in Medicare Part A and Part B 
            when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
            <ng-container *ngIf="selfPay.isOE">You cannot be enrolled in separate Part D coverage if your selected plan includes drug coverage.</ng-container>
          </p>

          <ng-container *ngTemplateOutlet="socialSecurityDisabilitySection"></ng-container>
        </div>
      </ng-template>

      <ng-template #socialSecurityDisabilitySection>
        <ng-container *ngIf="selfPay.isSebbCOBRA || selfPay.isSebbLwopInitial || selfPay.isSebbLwopOE">
          <div fxLayout="row" fxFlexFill>
            <kendo-formfield orientation="horizontal" fxFlex="40">
              <label class="k-label">Do you receive Social Security Disability?</label>
              <yes-no name="coveredByOtherSSD" style="width: auto;" orientation="horizontal-list" [stretch]="false" [(ngModel)]="currentSubscriber.coveredByOtherSSDInd"></yes-no>
            </kendo-formfield>
            <div class="form-inline">
              <date-picker #coveredByOtherSSDDate="ngModel" name="coveredByOtherSSDDate" [(ngModel)]="currentSubscriber.coveredByOtherSSDDate">
                <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
              </date-picker>
            </div>
          </div>
          <p *ngIf="!selfPay.isSebbCobraOE">
            If you answered Yes to receiving Social Security Disability, you must upload or send a copy of your Social Security Disability Award letter.
            If mailing, write your last name and the last four digits of your Social Security number on the copy so we can identify your account. You and your
            enrolled dependents may be eligible for additional months of coverage.
          </p>
          <p *ngIf="selfPay.isSebbCobraOE">
            If Yes, attach a copy of their Social Security Disability Award letter. Write your full name and the last four digits of your Social Security number
            on the copy. You and your enrolled dependents may be eligible for additional months of coverage.
          </p>
        </ng-container>
      </ng-template>

      <ng-template #iWantToSection>
        <!-- I want to section -->
        <div *ngIf="!selfPay?.isLWOP" class="form-row" fxFlexFill style="margin-bottom: 20px">
          <span class="soe-form-small-header">I want to</span>
          <span style="margin-bottom: 20px" *ngIf="selfPay.isPebbRetireeOE || selfPay.isSebbCOBRA || selfPay.isPebbCobraOE">
            Choose the coverage you wish to enroll in or remain enrolled in.
            <ng-container *ngIf="selfPay.isPebbRetireeOE">
              If you wish to end existing coverage, deselect the coverage and it will end on December 31 of the current year.
            </ng-container>
            <ng-container *ngIf="selfPay.isCobraOE">
              If you wish to terminate existing coverage, deselect the coverage and it will end on December 31 of the current year.
            </ng-container>
          </span>
          <div style="margin-bottom: 20px" fxFlex="100" *ngIf="currentSubscriber.actionsCode !== 'deferring'"><b>Enroll in (or remain enrolled)</b></div>
          <div style="margin-bottom: 20px" *ngIf="selfPay?.isCobraInitial">
            You may choose to continue coverage you were enrolled in on the day your {{agency}} health plan coverage ended. If you have {{agency}} life insurance you
            wish to port or convert, call MetLife at {{ selfPay.isPEBB ? '1-866-548-7139' : '1-833-854-9624' }}. If you are enrolled in a Flexible Spending Arrangement (FSA)
            or limited purpose FSA and would like to continue it, call Navia Benefit Solutions at 1-800-669-3539. Navia must receive your request no later than 60 days from the
            date your {{agency}} health plan coverage ended, or from the postmark date on Navia's COBRA election notice sent to you, whichever is later.            
          </div>
          <div style="margin-bottom: 20px" *ngIf="selfPay?.isPebbCobraInitial">
            If your employer group ended participation in PEBB or SEBB coverage: If you were previously enrolled in PEBB retiree term life insurance,
            you have the option to convert it by calling MetLife at <span style="white-space: nowrap;">1-866-548-7139</span>.
          </div>

          <div fxLayout="row" fxFlex="100" *ngIf="currentSubscriber.actionsCode !== 'deferring'" fxLayoutAlign="start center" style="margin-bottom: 20px" class="fxGap-medium-sm">
            <div fxLayout="row" fxFlex="100" *ngIf="!selfPay.isLWOP">
              <div class="k-form-field bigger" [fxFlex]="selfPay.isPebbRetireeInitial ? 22 : 30">
                <checkbox
                  name="medicalEnrollInd"
                  [(ngModel)]="currentSubscriber.medicalEnrollInd"
                  (ngModelChange)="handleMedicalEnrollChange($event)">Medical</checkbox>
              </div>
              <div class="k-form-field bigger" [fxFlex]="selfPay.isPebbRetireeInitial ? 22 : 30">
                <checkbox name="dentalEnrollInd" 
                [(ngModel)]="currentSubscriber.dentalEnrollInd"
                (ngModelChange)="handleDentalEnrollChange($event)"
                [disabled]="currentSubscriber.actionsCode === 'deferring' || (!currentSubscriber.medicalEnrollInd && selfPay.isRetiree)">Dental</checkbox>
              </div>
              <div class="k-form-field bigger" [fxFlex]="selfPay.isPebbRetireeInitial ? 22 : 30">
                <checkbox name="visionEnrollInd" 
                [(ngModel)]="currentSubscriber.visionEnrollInd"
                (ngModelChange)="handleVisionEnrollChange($event)"
                [disabled]="currentSubscriber.actionsCode === 'deferring' || (!currentSubscriber.medicalEnrollInd && selfPay.isRetiree) || (selfPay.isPEBB && currentSubscriber.medicarePartBInd)">Vision</checkbox>
              </div>
              <div *ngIf="selfPay.isPebbRetireeInitial" class="k-form-field bigger" [fxFlex]="22">
                <checkbox name="retireeTermLifeInd" 
                [(ngModel)]="currentSubscriber.retireeTermLifeInd"
                [disabled]="currentSubscriber.actionsCode === 'deferring'">Retiree term life insurance</checkbox>
              </div>             
            </div>
          </div>

          <div style="margin-bottom: 20px" *ngIf="selfPay.isPebbCOBRA">
            Enrollment in separate vision coverage is available only for members who are not enrolled in a PEBB Medicare plan.
            If you or a dependent are enrolled in Medicare Parts A and B and a PEBB Medicare plan, you cannot request to enroll in
            separate vision coverage. Your vision coverage is included in the Medicare plan, excluding Premera Plan F or G. Change the
            Medicare Part A or Part B responses to enroll in vision coverage if entered incorrectly.
          </div>
          <div *ngIf="selfPay.isPebbCobraOE" class="form-row" fxFlexFill>
            <ng-container *ngTemplateOutlet="terminateCoverageSection"></ng-container>
          </div>
          
          <div *ngIf="selfPay.isRetireeInitial">
            Enrollment in medical coverage is required to enroll in dental or vision coverage. If you or a dependent are enrolled in Medicare parts A and B,
            vision coverage is included in the Medicare plan, excluding Premera Supplement Plans. Change the Medicare A or B responses to request enrollment
            in vision coverage if entered incorrectly. Remove vision/dental enrollment by unchecking the boxes.
            <br/>
            <br/>
          </div>
          <span *ngIf="selfPay.isRetireeSOE">
            Enrollment in medical coverage is required to add dental or vision coverage.  Members who indicated they are enrolled in Medicare Parts A and B
            cannot request vision coverage as this is included in Medicare health benefits, exceptions apply to Plan G.  Change your Medicare A or B responses to
            request enrollment in vision coverage if entered incorrectly.  You can remove your vision/dental coverage enrollment by unchecking the correct benefit.
          </span>
          <div style="margin-bottom: 20px" >
            <b *ngIf="selfPay.isRetireeOE">
              Enrollment in medical coverage is required to enroll in dental or vision coverage. Enrollment in separate vision coverage is available only 
              for members who are not enrolled in Medicare. If you or a dependent are enrolled in Medicare Parts A and B, vision coverage is included in the Medicare
              plan, excluding Premera Supplement Plans. Change the Medicare Part A or Part B responses to enroll in vision coverage if entered incorrectly. Remove
              dental or vision enrollment by unchecking the boxes.
            </b>
            <b *ngIf="selfPay.isPebbCobraSOE">
              Enrollment in Medical Coverage is required to add dental or vision coverage. Members who indicated they are enrolled in Medicare Parts A and B
              cannot request in vision coverage as this is included in Medicare Health benefits, exceptions apply to Plan G. Change your Medicare A or B
              responses to request enrollment in vision coverage if entered incorrectly.
            </b>
          </div>
          
          <ng-container *ngIf="selfPay.isRetiree">
            <span style="margin-bottom: 20px">
              <b>Defer</b> (postpone) my coverage. Except as stated below, this terminates coverage for all eligible dependents.
              <ng-container *ngIf="selfPay.isRetireeOE">
                I understand I must also submit a <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">PEBB Medicare Plan Disenrollment form (form D)</a>
                if I am or an enrolled dependent is in a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP).
              </ng-container>
            </span>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="fxGap-medium-sm" style="margin-bottom: 20px">
              <div class="k-form-field bigger" fxFlex="30">
                <checkbox
                  name="deferCoverageInd"
                  [disabled]="currentSubscriber.actionsCode === 'deferring'"
                  [(ngModel)]="currentSubscriber.deferCoverageInd"
                  (ngModelChange)="updateCoverageDefer($event)">Defer</checkbox>
              </div>
              <div class="form-inline" fxFlex="30">
                <div class="form-group">
                  <date-picker
                    #deferCoverageDate="ngModel"
                    name="deferCoverageDate"
                    [required]="currentSubscriber.deferCoverageInd"
                    [(ngModel)]="currentSubscriber.deferCoverageDate">
                    <span style="white-space: nowrap; margin-right: 20px">Deferral date</span>
                  </date-picker>
                </div>
              </div>
              <div class="form-inline" fxFlex="30" *ngIf="selfPay.isPebbRetireeSOE">
                If we receive this form on the first of the month, the deferral is effective that day.  If you or an enrolled dependent are in a Medicare Advantage plan or Medicare Part D, you must also submit a PEBB Medicare Advantage Plan Disenrollment Form (form D) with this form.  The deferral is effective on the first of the month after the date the PEBB Program receives this request and Form D. 
              </div>
            </div>
            <div>Select your reason for deferring coverage, below.<br/></div>
            <span style="margin-bottom: 20px" *ngIf="currentSubscriber.actionsCode !== 'deferring'"
              ><b>Enroll after deferring coverage:</b> 
              <span *ngIf="selfPay.isRetireeInitial">
                If you deferred enrollment while enrolled in qualifying coverage, you must provide proof of your continuous enrollment in one or more
                qualifying coverages since you deferred (showing start and end dates). If your enrollment was deferred while enrolled in Medicare and
                permanently residing outside of the United States or during a temporary absence from the United States that exceeds the permitted time
                allowed, and you have now returned to  the U.S., you must provide proof of enrollment in Medicare Part A and Part B, proof of permanent
                residence in the U.S., and proof you currently reside in the U.S. Proof of continuous enrollment in qualified coverage is not required
                while living outside of the U.S.
              </span>
              <span *ngIf="selfPay.isRetireeSOE">
                When you later enroll, you must provide proof of continuous enrollment in one or more qualifying coverages (with start and end dates).
                A gap of 31 days or less is allowed between the date PEBB retiree coverage is deferred and the start date of a qualifying coverage, and
                between each qualifying coverage during the deferral period.
              </span>
              <span *ngIf="selfPay.isRetireeOE">
                If you deferred enrollment while enrolled in qualifying coverage, you must provide proof of your continuous enrollment in one or more
                qualifying coverages since you deferred. If your enrollment was deferred while enrolled in Medicare and permanently residing outside of
                the United States or during a temporary absence from the United States that exceeds the permitted time allowed, and you have now returned
                to the U.S., you must provide proof of enrollment in Medicare Part A and Part B, proof of permanent residence in the U.S., and proof you
                currently reside in the U.S. Proof of continuous enrollment in qualified coverage is not required while living outside of the U.S.
              </span>
            </span>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="fxGap-medium-sm" style="margin-bottom: 20px"
              *ngIf="currentSubscriber.actionsCode !== 'deferring'">
              <div class="k-form-field bigger" fxFlex="30">
                <checkbox
                  name="enrollAfterDeferalInd"
                  [(ngModel)]="currentSubscriber.enrollAfterDeferalInd"
                  [disabled]="currentSubscriber.deferCoverageInd || !currentSubscriber.medicalEnrollInd"
                  (ngModelChange)="updateEnrollAfterDefer($event)">Enroll after deferring</checkbox>
              </div>
              <div class="form-inline">
                <div class="form-group">
                  <date-picker
                    #enrollAfterDeferralDate="ngModel"
                    name="enrollAfterDeferralDate"
                    [required]="currentSubscriber.enrollAfterDeferalInd"
                    [(ngModel)]="currentSubscriber.enrollAfterDeferalDate">
                    <span *ngIf="!selfPay.isRetireeInitial" style="white-space: nowrap; margin-right: 20px">Date other qualifying coverage ended:</span>
                    <span *ngIf="selfPay.isRetireeInitial" style="white-space: nowrap; margin-right: 20px">If you deferred enrollment while enrolled in other qualifying medical coverage, provide the date the coverage ended:</span>
                  </date-picker>
                </div>
              </div>
            </div>
          </ng-container>

          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="fxGap-medium-sm" style="margin-bottom: 20px" *ngIf="selfPay.isPebbRetireeOE || selfPay.isPebbRetireeSOE || selfPay.isCobraOE">
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox
                name="terminateCoverageInd"
                [disabled]="currentSubscriber.actionsCode === 'deferring'"
                [(ngModel)]="currentSubscriber.terminateAllCoverageInd"
                (ngModelChange)="terminateAllCoveragesChange($event)">Terminate all coverage(s)</checkbox>
            </div>
            <div *ngIf="selfPay.isSebbCOBRA" class="form-inline">
              If you terminate all coverage, your coverage will end December 31 of the current year.
            </div>
            <div *ngIf="(selfPay?.isPEBB && selfPay?.isCOBRA) || selfPay.isRetireeOE" class="form-inline">
              <div>
              Coverage will {{ selfPay.isRetireeOE ? 'terminate' : 'end' }} December 31 of the current year. I understand I cannot reenroll unless I regain eligibility. I understand I must also submit a <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=51-0556&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_be">PEBB Medicare Plan Disenrollment form (form D)</a> if I am or an enrolled dependent is in a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP).  
              </div>
            </div>
            <ng-container *ngIf="selfPay.isRetireeSOE">
              <div class="form-inline" fxFlex="30">
                <div class="form-group">
                  <date-picker
                    #terminateAllCoverageDate="ngModel"
                    name="terminateAllCoverageDate"
                    [required]="currentSubscriber.terminateAllCoverageInd"
                    [(ngModel)]="currentSubscriber.terminateAllCoverageDate">
                    <span style="white-space: nowrap; margin-right: 20px">Termination date</span>
                  </date-picker>
                </div>
              </div>
              <div class="form-inline" fxFlex="30">
                I understand by terminating coverage I am forfeiting all further rights to enroll again unless I rgain eligibility.  I understand I must
                also submit a PEBB Medicare Advantage Plan Disenrollment Form (form D) if I or an enrolled dependent is in an Medicare Advantage Plan
                or Medicare Part D.
              </div>
            </ng-container>
          </div>
          
          <div *ngIf="selfPay.isCobraInitial || selfPay.isPebbCobraSOE" class="form-row" fxFlexFill>
            <ng-container *ngTemplateOutlet="terminateCoverageSection"></ng-container>
          </div>

          <div *ngIf="selfPay.isPebbCobraInitial || selfPay.isPebbCobraSOE" fxFlexFill>
            <h4 *ngIf="selfPay.isPebbCobraSOE">
              <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
              If you terminate all coverage, you will not be eligible to enroll again in {{agency}} Continuation Coverage unless you regain eligibility.
            </h4>
            <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
          </div>
          
          <div *ngIf="selfPay.isRetireeOE || selfPay.isRetireeInitial">
            <span style="margin-bottom: 20px">
              <b>If deferring or enrolling after deferring, check all the boxes below that apply to you.</b>
            </span>
            <div class="hca-self-pay-checklist fxGap-medium-sm" fxLayout="column" fxLayoutAlign="space-between start" style="margin-bottom: 20px">
              <div class="k-form-field bigger">
                <checkbox name="deferQuestionOne" [(ngModel)]="currentSubscriber.deferQuestionOne">
                  Enrolled as a dependent in a medical plan sponsored by the PEBB Program or the School Employees Benefits Board (SEBB) Program. This
                  includes coverage under COBRA or continuation coverage.
                </checkbox>
              </div>
              <div class="k-form-field bigger">
                <checkbox name="deferQuestionTwo" [(ngModel)]="currentSubscriber.deferQuestionTwo">
                  Enrolled in employer-based group medical as an employee or employee's dependent, including medical insurance continued under COBRA or
                  continuation coverage. <b>This does not include an employer's retiree coverage</b>.
                </checkbox>
              </div>
              <div class="k-form-field bigger">
                <checkbox name="deferQuestionThree" [(ngModel)]="currentSubscriber.deferQuestionThree">
                  Enrolled in medical coverage as a retiree or dependent of a retiree in a TRICARE plan or the Federal Employees Health Benefits Program. You
                  have a one-time opportunity to enroll in a PEBB retiree health plan.
                </checkbox>
              </div>
              <div class="k-form-field bigger">
                <checkbox name="deferQuestionFour" [(ngModel)]="currentSubscriber.deferQuestionFour">
                  Enrolled in the Civilian Health and Medical Program of the Department of Veterans Affairs (CHAMPVA). You have a one-time opportunity
                  to enroll in a PEBB retiree health plan.
                </checkbox>
              </div>
              <ng-container *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeSOE">
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionFive" [(ngModel)]="currentSubscriber.deferQuestionFive">
                    <b>Non-Medicare subscribers only:</b> Enrolled in qualified health plan coverage through a health benefit exchange established under
                    the Affordable Care Act. This does not include Medicaid (called Apple Health in Washington State). You have a one-time opportunity to
                    enroll or reenroll in a PEBB retiree health plan.
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionSix" [(ngModel)]="currentSubscriber.deferQuestionSix">
                    <b>Medicare subscribers only:</b> Enrolled in Medicare Parts A and B and a Medicaid program that provides creditable coverage. You may continue to cover eligible dependents who are not eligible for creditable coverage under Medicaid.
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionSeven" [(ngModel)]="currentSubscriber.deferQuestionSeven">
                    <b>Medicare subscribers only:</b> Retirees and survivors enrolled in Medicare may defer enrollment if they permanently reside outside of the United States.
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionEight" [(ngModel)]="currentSubscriber.deferQuestionEight">
                    <b>Medicare subscribers only:</b> Effective January 1, 2026, retirees and survivors enrolled in Medicare may defer enrollment if they have a temporary absence from the United States that exceeds the permitted time allowed under the federal regulations and guidance of CMS.
                  </checkbox>
                </div>
              </ng-container>
              <ng-container *ngIf="selfPay.isRetireeOE">
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionFive" [(ngModel)]="currentSubscriber.deferQuestionFive">
                    <b>Medicare subscribers only:</b> Enrolled in Medicare Parts A and B and a Medicaid program that provides creditable coverage. You may continue to cover eligible dependents who are not eligible for creditable coverage under Medicaid.
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionSix" [(ngModel)]="currentSubscriber.deferQuestionSix">
                    <b>Medicare subscribers only:</b> Retirees and survivors enrolled in Medicare may defer enrollment if they permanently reside outside of the United States.
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionSeven" [(ngModel)]="currentSubscriber.deferQuestionSeven">
                    <b>Medicare subscribers only:</b> Retirees and survivors enrolled in Medicare may defer enrollment if they have a temporary absence from the United States that exceeds the permitted time allowed under the federal regulations and guidance of the Centers for Medicare and Medicaid Services (CMS).
                  </checkbox>
                </div>
                <div class="k-form-field bigger">
                  <checkbox name="deferQuestionEight" [(ngModel)]="currentSubscriber.deferQuestionEight">
                    <b>Non-Medicare subscribers only:</b> Enrolled in qualified health plan coverage through a health benefit exchange established under
                    the Affordable Care Act. This does not include Medicaid (called Apple Health in Washington State). You have a one-time opportunity to
                    enroll or reenroll in a PEBB retiree health plan.
                  </checkbox>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #retireeLifeSection>
        <!-- Retiree Life Insurance section -->
        <div *ngIf="selfPay.isRetireeInitial" class="form-row" fxFlexFill>
          <span class="soe-form-small-header">Retiree term life insurance</span>
          <p>
            Retiree term life insurance is available only if you received PEBB life insurance as an employee or SEBB life insurance as a school employee. You are not eligible 
            for the retiree term life insurance plan if you qualify for a waiver of premium benefit under the PEBB employee life insurance or SEBB employee life insurance 
            plans until that waiver of premium benefit ends. To apply for retiree term life insurance, upload the <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=MetLife+Retiree+Enrollment%2FChange+form&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC">PEBB MetLife Enrollment/Change Form for Retiree Plan</a> (including beneficiary designation). 
          </p>
          <div fxFlexFill *ngIf="!selfPay.isRetireeOE" class="k-form-field bigger">
            <checkbox name="retireeTermLifeAcknowledgeInd" [(ngModel)]="currentSubscriber.retireeTermLifeAcknowledgeInd">
              I acknowledge that I will upload the <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=MetLife+Retiree+Enrollment%2FChange+form&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC">PEBB MetLife Enrollment/Change form for Retirees</a>
            </checkbox>
          </div>
        </div>
      </ng-template>

      <ng-template #premiumSurchargeSection>
        <!-- Premium Surcharge section -->
        <div class="form-row" fxLayout="row" fxFlexFill *ngIf="currentSubscriber.actionsCode !== 'deferring'">
          <span class="soe-form-small-header">Tobacco use premium surcharge</span>
          <p>
            {{ (!selfPay.isPebbCobraOE && (selfPay.isCOBRA || selfPay.isRetireeInitial)) ? '' : 'Response required if you are enrolling in medical coverage.' }}
            The {{agency}} Program requires a $25-per-account premium surcharge in addition to your monthly medical premium if you or
            an enrolled dependent (age 13 and older) {{ (selfPay.isPebbCobraInitial || selfPay.isPebbLwopInitial) ? 'on your PEBB' : ('enrolled on your ' || agency)}}
            medical coverage uses a tobacco product. Tobacco use is defined as any use of tobacco products within the past two months
            except for religious or ceremonial use.
            <ng-container *ngIf="selfPay.isSEBB">
                <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/tobacco-use-surcharge">Learn more about this surcharge before you attest</a>.
            </ng-container>
            <ng-container *ngIf="!selfPay.isSEBB">
              <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/tobacco-use-surcharge">Learn more about this surcharge before you attest.</a>
            </ng-container>
          </p>
          <div *ngIf="!selfPay.isSEBB && selfPay.medicareAvailable && (selfPay.isInitial || selfPay.isOE)" fxFlexFill>
            Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B.<br/><br/>
          </div>

          <p *ngIf="selfPay.isLwopSOE">
            Tobacco products are any product made with or derived from tobacco that is intended for human consumption, including any component, part, or accessory of a tobacco product. This includes, but is not limited to, cigars, cigarettes, pipe tobacco, chewing tobacco, snuff, and other tobacco products. Tobacco products do not include e-cigarettes or United States Food and Drug Administration (FDA) approved quit aids, such as all over-the-counter nicotine replacement products if recommended by a doctor, or prescription nicotine replacement products. 
          </p>
          <p *ngIf="selfPay.isPebbLwopSOE || selfPay.isRetireeSOE">
            If a provider finds that ending tobacco use or participating in your medical plan's tobacco cessation program will negatively affect your or your dependent's health, see more information in
            the <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-rules-and-policies">{{agency}} Program Administrative Policy 91-1</a>.
          </p>
          <p *ngIf="selfPay.isSebbLwopSOE">
            If a provider finds that ending tobacco use or participating in your medical plan's tobacco cessation program will negatively affect your or your dependent's health, see more information in
            the <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-rules-and-policies">{{agency}} Program Administrative Policy 91-1</a>.
          </p>          
          <p *ngIf="selfPay.isLwopSOE || selfPay.isRetireeSOE">
            The premium surcharge will not apply if you and any enrolled dependents who use tobacco products meet these requirements: If you check No, enrolled in the free tobacco cessation program through your PEBB medical plan (age 18 and older), or accessed resources for teens on Smokefree Teen's website.
          </p>

          <p fxFlexFill>
            <b>If you check Yes or leave this section blank, you will be charged the $25 premium surcharge. </b>
            <a *ngIf="selfPay.isPebbLwopSOE || selfPay.isRetireeSOE" target="_blank" [href]="selfPay.isRetiree ? 'https://www.hca.wa.gov/employee-retiree-benefits/retirees/tobacco-use-surcharge' : 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/tobacco-use-surcharge'">Learn more about this surcharge before you attest.</a>
            <a *ngIf="selfPay.isSebbLwopSOE" target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/surcharges">Learn more about this surcharge before you attest.</a>
          </p>

          <span style="margin-bottom: 20px"> <b>Does the tobacco use premium surcharge apply to you?</b> Check one: </span>
          <div class="form-row" fxFlexFill>
            <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
              <div class="hca-self-pay-checklist fxGap-medium-sm" fxLayout="column" fxLayoutAlign="space-between start" style="margin-bottom: 20px">
                <radio name="tobaccoUseFormIndNo" value="No" [(ngModel)]="currentSubscriber.tobaccoUseFormInd" [disabled]="currentSubscriber.medicarePartAInd && currentSubscriber.medicarePartBInd">
                  <span class="hca-mid-sz">No, I am not subject to the $25 premium surcharge. I have not used tobacco products in the past two months, or I have enrolled in 
                    <span *ngIf="selfPay.isRetireeOE || selfPay.isCOBRA || selfPay.isLwopInitial || selfPay.isLwopOE">or accessed </span>
                    <span *ngIf="!(selfPay.isRetireeOE || selfPay.isCOBRA || selfPay.isLwopInitial || selfPay.isLwopOE)">my {{agency}} medical plan's </span> 
                    <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'">
                      tobacco cessation 
                      <span *ngIf="selfPay.isRetireeOE || selfPay.isCOBRA || selfPay.isLwopOE || selfPay.isLwopInitial">resources</span>
                      <span *ngIf="!(selfPay.isRetireeOE || selfPay.isCOBRA || selfPay.isLwopOE || selfPay.isLwopInitial)">program</span>
                    </a>.
                  </span>
                </radio>
                <radio *ngIf="selfPay.medicareAvailable" name="tobaccoUseFormInd" value="NA" [(ngModel)]="currentSubscriber.tobaccoUseFormInd">
                  No, I am enrolled in Medicare Part A and Part B. The premium surcharge does not apply. 
                </radio>
                <radio name="tobaccoUseFormIndYes" value="Yes" [(ngModel)]="currentSubscriber.tobaccoUseFormInd" [disabled]="currentSubscriber.medicarePartAInd && currentSubscriber.medicarePartBInd">
                  Yes, I am subject to the $25 premium surcharge. I have used tobacco products in the past two months. 
                </radio>
              </div>
            </div>
          </div>
        </div>  
      </ng-template>
              
      <ng-template #terminateCoverageSection>
        <div class="form-row" fxFlexFill>
          <div class="form-row" fxFlexFill style="margin-bottom: 20px">
            <div fxLayout="column" fxFlexFill>
              <span class="soe-form-small-header">Terminate coverage (Select all that apply)</span>
              <div *ngIf="!selfPay.isSebbLwopOE && !selfPay.isSebbLwopInitial">
                You may choose to continue coverage and then terminate it at a future date by selecting to both continue and terminate coverage and
                providing a termination date and reason below.
              </div>
              <div *ngIf="selfPay.isSebbCobraInitial || selfPay.isSebbLwopOE || selfPay.isSebbLwopInitial">
                <p>
                  If you terminate all coverage, you will not be eligible to enroll again in SEBB Continuation Coverage unless you regain eligibility.
                  <ng-container *ngIf="selfPay.isSebbLwopInitial || selfPay.isSebbLwopOE">
                    If you have SEBB life insurance you wish to port, convert, or terminate, call MetLife at 1-833-854-9624.
                  </ng-container>
                </p>
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
                <div class="k-form-field bigger" *ngIf="(selfPay.isLWOP || selfPay.isRetireeInitial || selfPay.isRetireeSOE) || selfPay?.isPebbCobraOE || selfPay?.isCobraSOE || currentSubscriber.medicalEnrollInd">
                  <checkbox name="medicalTerminateCoverage" [(ngModel)]="currentSubscriber.medicalTerminateCoverage">Medical</checkbox>
                </div>
                <div class="k-form-field bigger" *ngIf="(selfPay.isLWOP || selfPay.isRetireeInitial || selfPay.isRetireeSOE) || selfPay?.isPebbCobraOE || selfPay?.isCobraSOE || currentSubscriber.dentalEnrollInd">
                  <checkbox name="dentalTerminateCoverage" [(ngModel)]="currentSubscriber.dentalTerminateCoverage">Dental</checkbox>
                </div>
                <div class="k-form-field bigger" *ngIf="(selfPay.isLWOP || selfPay.isRetireeInitial || selfPay.isRetireeSOE) || selfPay?.isCobraOE || selfPay?.isCobraSOE || currentSubscriber.visionEnrollInd">
                  <checkbox name="visionTerminateCoverage" [(ngModel)]="currentSubscriber.visionTerminateCoverage">Vision</checkbox>
                </div>
                <div class="k-form-field bigger" *ngIf="selfPay.isSebbLwopSOE || selfPay.isPebbLwopInitial || selfPay.isPebbLwopOE">
                  <checkbox name="terminateLongTermDisabilityContinueCoverageInd" [(ngModel)]="currentSubscriber.terminateLongTermDisabilityContinueCoverageInd">
                    Long-term disability insurance (only if on educational or USERRA military leave) insurance
                  </checkbox>
                </div>           
              </div>
              <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
                <div class="form-group" fxFlex="25">
                  <date-picker
                    #terminationDate="ngModel"
                    name="terminationDate"
                    label="Termination date"
                    [required]="currentSubscriber.medicalTerminateCoverage || currentSubscriber.dentalTerminateCoverage || currentSubscriber.terminateLifeAndADDCoverageInd"
                    onlyAllowLastOfMonth
                    [(ngModel)]="currentSubscriber.medicalTerminateCoverageDate"></date-picker>
                </div>
                <div class="form-group" fxFlex="70">
                  <label for="ultermreason">Term Reason</label>
                  <input
                    [required]="currentSubscriber.medicalTerminateCoverage || currentSubscriber.dentalTerminateCoverage || currentSubscriber.terminateLifeAndADDCoverageInd"
                    type="text"
                    class="form-control"
                    name="ultermreason"
                    id="ultermreason"
                    [(ngModel)]="currentSubscriber.medicalTerminateCoverageReason"
                  />
                </div>
              </div>
              <div *ngIf="selfPay.isPebbCobraInitial" style="margin-bottom: 20px">
                  I understand I must also submit a PEBB Medicare Plan Disenrollment form (form D) if I am or an enrolled dependent is in a Medicare Advantage
                  with Part D plan or UMP Classic Medicare with Part D (PDP).  
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #otherCoverageSection>
        <h4 *ngIf="!(selfPay.isCobraInitial && !selfPay.isSEBB)">
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          You may choose to continue coverage you were enrolled in on the day your {{agency}} health plan coverage ended. If you have {{agency}} life insurance you wish to port or convert, call MetLife at
          <span style="white-space: nowrap;">1-866-548-7139</span>. If you are enrolled in a Flexible Spending Arrangement (FSA) or limited purpose FSA and would like to continue it, call Navia Benefit Solutions at 1-800-669-3539. Navia must receive your
          request <b>no later than 60 days</b> from the date your {{agency}} health plan coverage ended, or from the postmark date on Navia's COBRA election notice sent to you, whichever is later.
        </h4>
        <!-- SOCIAL SECURITY/OTHER COVERAGE SECTION -->
        <div fxLayout="row" *ngIf="!(selfPay.isCobraInitial && !selfPay.isSEBB)">
          <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
            <label class="k-label">Are you covered by another group medical plan?</label>
            <yes-no
              name="coveredByOtherMedical"
              style="width: auto;"
              orientation="horizontal-list"
              [stretch]="false"
              [(ngModel)]="currentSubscriber.coveredByOtherMedicalInd"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline">
            <div class="form-group">
              <date-picker
                #coveredByOtherMedicalDate="ngModel"
                name="coveredByOtherMedicalDate"
                labelFlex="50"
                inputFlex="50"
                [required]="currentSubscriber.coveredByOtherMedicalInd"
                [(ngModel)]="currentSubscriber.coveredByOtherMedicalDate">
                <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
              </date-picker>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxFlexFill *ngIf="!(selfPay.isCobraInitial && !selfPay.isSEBB)">
          <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
            <label class="k-label">Are you covered by another group dental plan?</label>
            <yes-no
              name="coveredByOtherDental"
              style="width: auto;"
              orientation="horizontal-list"
              [stretch]="false"
              [(ngModel)]="currentSubscriber.coveredByOtherDentalInd"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline">
            <div class="form-group">
              <div class="input-group">
                <date-picker
                  #coveredByOtherDentalDate="ngModel"
                  name="coveredByOtherDentalDate"
                  labelFlex="50"
                  inputFlex="50"
                  [required]="currentSubscriber.coveredByOtherDentalInd"
                  [(ngModel)]="currentSubscriber.coveredByOtherDentalDate">
                <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
              </date-picker>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxFlexFill *ngIf="selfPay.isSEBB">
          <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
            <label class="k-label">Are you covered by another group vision plan?</label>
            <yes-no
              name="coveredByOtherVision"
              style="width: auto;"
              orientation="horizontal-list"
              [stretch]="false"
              [(ngModel)]="currentSubscriber.coveredByOtherVisionInd"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline">
            <div class="form-group">
              <div class="input-group">
                <date-picker
                  #coveredByOtherVisionDate="ngModel"
                  name="coveredByOtherVisionDate"
                  labelFlex="50"
                  inputFlex="50"
                  [required]="currentSubscriber.coveredByOtherVisionInd"
                  [(ngModel)]="currentSubscriber.coveredByOtherVisionDate">
                <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
              </date-picker>
              </div>
            </div>
          </div>
        </div>          
        <div fxLayout="row" fxFlexFill>
          <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
            <label class="k-label">Do you receive Social Security Disability?</label>
            <yes-no
              name="coveredByOtherSSD"
              style="width: auto;"
              orientation="horizontal-list"
              [stretch]="false"
              [(ngModel)]="currentSubscriber.coveredByOtherSSDInd"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline" >
            <div class="form-group">
              <date-picker
                #coveredByOtherSSDDate="ngModel"
                name="coveredByOtherSSDDate"
                labelFlex="50"
                inputFlex="50"
                [required]="currentSubscriber.coveredByOtherSSDInd"
                [(ngModel)]="currentSubscriber.coveredByOtherSSDDate">
                <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
              </date-picker>
            </div>
          </div>
        </div>
        <h4>
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you answered Yes to receiving Social Security Disability, you must upload or send a copy of your Social Security Disability Award letter. If mailing, write your last name and the last four digits of
          your Social Security number on the copy so we can identify your account. You and your enrolled dependents may be eligible for additional months of coverage.
        </h4>
      </ng-template>

      <ng-template #endCoverageDateSection>
        <div class="form-group">
          <h3>&nbsp;</h3>
          <date-picker
            #activeCoverageEndDate="ngModel"
            name="activeCoverageEndDate"
            [(ngModel)]="currentSubscriber.activeCoverageEndDate">
            <span *ngIf="selfPay.isCOBRA && !selfPay.isSebbCobraInitial">Enter the date employer group ended participation (if known)</span>
            <span *ngIf="selfPay.isSebbCobraInitial || !selfPay.isCOBRA">Enter the date {{ agency }} health plan coverage ended (if known)</span>
          </date-picker>
        </div>
      </ng-template>
    </form>
  </div>
</div>